import { PaginationParams } from "./types";

export const DEFAULT_PAGINATION: PaginationParams = { page: 1, perPage: 25 }